import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  COORDINATOR_ROLE,
  CUSTOMER_CARER_ROLE,
  CUSTOMER_FAMILY_REPRESENTATIVE_ROLE,
  CUSTOMER_FAMILY_ROLE,
  CUSTOMER_SELF_ROLE,
  DASHBOARD_ROLES,
  ORGANISATION_ADMIN_ROLE,
} from '@careapp-group/core';
import { SelectRoleDialogComponent } from '../select-role-dialog/select-role-dialog.component';
import { environment } from '../../../environments/environment';
import { CA_ENVIRONMENT } from '../../app.di';

@Component({
    styleUrls: ['./link-card.component.scss'],
    templateUrl: './link-card.component.html',
    selector: 'ca-link-card',
    standalone: false
})
export class LinkCardComponent {
  DASHBOARD_ROLES = DASHBOARD_ROLES;
  NULL_ROLES_VISIBILITY = [ORGANISATION_ADMIN_ROLE, COORDINATOR_ROLE, CUSTOMER_CARER_ROLE];
  @Output() setVisibility = new EventEmitter();
  @Output() removeLink = new EventEmitter();
  @Output() viewHistory = new EventEmitter();

  @Input() loading: boolean;
  @Input() description: string;
  @Input() roles: string[];
  @Input() url: string;

  constructor(private dialog: MatDialog, @Inject(CA_ENVIRONMENT) private environment) {}

  updateRoles() {
    let currentRoles = this.roles ?? this.NULL_ROLES_VISIBILITY;

    const dialogRef = this.dialog.open(SelectRoleDialogComponent, {
      width: '500px',
      data: {
        selectedRoles: currentRoles,
        disabledRoles: [ORGANISATION_ADMIN_ROLE, COORDINATOR_ROLE],
        roleOptions: this.environment.documents.shareToFamilyRepresentatives
          ? [
              ORGANISATION_ADMIN_ROLE,
              COORDINATOR_ROLE,
              CUSTOMER_CARER_ROLE,
              CUSTOMER_SELF_ROLE,
              CUSTOMER_FAMILY_REPRESENTATIVE_ROLE,
            ]
          : [
              ORGANISATION_ADMIN_ROLE,
              COORDINATOR_ROLE,
              CUSTOMER_CARER_ROLE,
              CUSTOMER_SELF_ROLE,
              CUSTOMER_FAMILY_ROLE,
            ],
      },
    });

    dialogRef.afterClosed().subscribe((dialogRoles: string[]) => {
      if (!dialogRoles) {
        return;
      }

      this.setVisibility.emit(dialogRoles);
    });
  }
}
